import { forwardRef, type ReactNode } from 'react';
import clsx from 'clsx';

import { Button, type ButtonProps } from './Button';
import styles from './IconButton.module.css';

export interface IconButtonProps
  extends Omit<ButtonProps, 'children' | 'icon' | 'iconOnly' | 'iconTrailing'> {
  /** The accessible name. Rendered visually hidden — never optional. */
  label: string;
  icon: ReactNode;
  /** Toggle buttons (a toolbar filter, a lens switch) report `aria-pressed`. */
  pressed?: boolean;
}

/**
 * Built on `Button` rather than beside it: a toolbar icon and a form button must
 * not drift in height, focus ring or disabled treatment.
 */
export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(function IconButton(
  { label, icon, pressed, variant = 'ghost', className, ...rest },
  ref,
) {
  return (
    <Button
      {...rest}
      ref={ref}
      variant={variant}
      icon={icon}
      iconOnly
      aria-pressed={pressed}
      className={clsx(styles.iconButton, pressed === true && styles.pressed, className)}
      title={label}
    >
      {label}
    </Button>
  );
});
